import dayjs from 'dayjs';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { ROLE_VEHICLE_MANAGER } from '../../../redux/constants/rolesConstants';
import { getMyEventsAction } from '../../../redux/actions/eventsActions';
import Button from '../../shared/buttons/Button';
import CreateEventModal from '../modals/CreateEventModal';
import CalendarHeader from './CalendarHeader';
import CalendarViewControl from './CalendarViewControl';

const CalendarToolbar = ({ onView, onNavigate, view, date }) => {
  const dispatch = useDispatch();
  const [showCreateEventModal, setShowCreateEventModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));

  const handleEventModalSubmit = async () => {
    setShowCreateEventModal(false);
    setLoading(true);
    await dispatch(getMyEventsAction(dayjs(date).toISOString()));
    setLoading(false);
  };

  return (
    <div>
      {showCreateEventModal && (
        <CreateEventModal
          onModalSubmit={() => handleEventModalSubmit()}
          onModalClose={() => setShowCreateEventModal(false)}
        />
      )}
      <div className="flex flex-col">
        <div className="flex justify-between mb-6">
          <div className="text-lg md:text-2xl">{date.getFullYear()}</div>
          {!readOnly && (
            <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateEventModal(true)}>
              <AiOutlinePlus />
              Додати
            </Button>
          )}
        </div>
        <div className="flex justify-between w-full mb-4">
          <CalendarHeader label={date.toLocaleString('uk-UA', { month: 'long' })} onNavigate={onNavigate} />
          <CalendarViewControl onView={onView} view={view} />
        </div>
      </div>
    </div>
  );
};

export default CalendarToolbar;
